import moment from 'moment'
import 'moment-timezone'
import {mapGetters} from "vuex";
export const date_time_converters = {
    methods: {
        json_to_date_obj (json_datetime) {
            if (!json_datetime) return null
            return moment(json_datetime['$date']).tz(this.$store.state.current_system_timezone)
        },
        json_to_date_picker_str (json_datetime) {
            if (!json_datetime) return null
            return this.json_to_date_obj(json_datetime).startOf('day').format('YYYY-MM-DD')
        },
        json_to_time_str (json_datetime) {
            if (!json_datetime) return null
            return this.json_to_date_obj(json_datetime).format('HH:mm')
        },
        json_to_date_slash_str (datetime) {
            if (!datetime) return null
            return moment(datetime['$date']).tz(
                this.$store.state.current_system_timezone
            ).startOf('day').format('DD/MM/YYYY')
        },
        picker_date_time_to_date_obj (date, time) {
            if (!date || !time) return null
            const [year, month, day] = date.split('-')
            const [hour, minutes] = time.split(':')
            date = new Date(year, month-1, day, hour, minutes,)
            return date
        },
        picker_date_time_to_json (date, time) {
            let date_obj = this.picker_date_time_to_date_obj(date, time)
            if (!date) return null
            return this.date_obj_to_json(date_obj)
        },
        picker_date_to_slash_str (picker_date) {
            if (!picker_date) return null
            const [year, month, day] = picker_date.split('-')
            return `${day}/${month}/${year}`
        },
        date_obj_to_datetime_str (datetime_obj) {
            return moment(datetime_obj).tz(
                this.$store.state.current_system_timezone
            ).format('HH:mm:ss DD/MM/YYYY')
        },
        date_obj_to_json (date_obj) {
            return {
                '$date': moment(date_obj).tz(this.$store.state.current_system_timezone, true).utc().format()
            }
        },
        time_str_to_minutes (time_str) {
           const [hours, minutes] = time_str.split(':')
            return parseInt(hours) * 60 + parseInt(minutes)
        },
        minutes_to_time_str (minutes) {
            let hours = parseInt(minutes / 60)
            hours = hours > 10 ? hours : `0${hours}`
            minutes = minutes % 60
            minutes = minutes >= 10 ? minutes : `0${minutes}`
            return `${hours}:${minutes}`
        },
        ...mapGetters(['timezonesInfo'])
    }
}